import { root, ISingleServiceInfo } from '../UniversalUtils';

const extractServiceVersion = (serviceInfo: ISingleServiceInfo) =>
    serviceInfo && serviceInfo.version;

const searchForServiceInfo = (serviceName: string) =>
    root.serviceInfo[serviceName] || root.ServiceRegistry[serviceName];

export const getServiceVersion = (serviceName: string, fallback: string = '') =>
    extractServiceVersion(searchForServiceInfo(serviceName)) || fallback;
